// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"100":"af7521f3","330":"dae7c10f","370":"482c9601","563":"a2f6045b","710":"67e9074b","713":"248a4597","832":"706150b2","845":"5d434e29","915":"ee20be85"}[chunkId] + ".js";
};